/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { REPORTCONFIGURATION } from './rEPORTCONFIGURATION';


export interface REPORTSCHEDULE {
    /**
     * Schedule entry unique ID. Optional. Will be returned on schedule entry creation 
     */
    id?: string;
    configuration: REPORTCONFIGURATION;
    /**
     * Reporting period
     */
    periodType: REPORTSCHEDULE.PeriodTypeEnum;
    /**
     * Offset with the period   hour (from 0 to 23) for daily reports   day of week (0 for Sunday) - for weekly reports   day of month (from to 28)- for monthly reports 
     */
    offset?: number;
}
export namespace REPORTSCHEDULE {
    export type PeriodTypeEnum = 'DAILY' | 'WEEKLY' | 'MONTHLY';
    export const PeriodTypeEnum = {
        DAILY: 'DAILY' as PeriodTypeEnum,
        WEEKLY: 'WEEKLY' as PeriodTypeEnum,
        MONTHLY: 'MONTHLY' as PeriodTypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/rEPORTSCHEDULE.ts